import { CaseAPI as baseURL, API } from "./axios.config";
import { getAppConfig } from "../services/configService";
export * from "./accountsAPI.js";

export const updateMatter = (id, data) =>
  API.patch(`/matters/${id}`, JSON.stringify(data), {
    headers: { "Content-Type": "application/json" },
  });

export const updateAdditionalClients = (matterId, additionalClients) =>
  API.patch(
    `/Matters/${matterId}/AdditionalClients`,
    JSON.stringify({ data: additionalClients }),
    { headers: { "Content-Type": "application/json-patch+json" } },
  );

export const sendMail = (matterId, data) =>
  API.post(`/CaseFile/${matterId}/NewEmail`, JSON.stringify(data), {
    headers: { "Content-Type": "application/json" },
  });

export const addMatter = (data) =>
  API.post(`/matters`, JSON.stringify(data), {
    headers: { "Content-Type": "application/json" },
  });

export const saveActivity = (id, data) =>
  API.post(`/MatterActivities/${id}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const getRecordedTime = (
  feeEarner,
  status,
  FromDate,
  ToDate,
  matterId,
  page,
  limit,
  orderBy,
  branchId,
  teamId,
) => {
  const params = new URLSearchParams({
    page: String(page),
    limit: String(limit),
  });

  if (status?.value !== "" && status?.value != null) {
    params.append("Billed", String(status.value));
  }
  if (FromDate) params.append("FromDate", FromDate);
  if (ToDate) params.append("ToDate", ToDate);
  if (matterId) params.append("matterId", matterId);
  const accessFilterParams = constructApiQuery(branchId, teamId, feeEarner);
  Object.entries(accessFilterParams).forEach(([key, value]) =>
    params.append(key, value),
  );
  if (orderBy) params.append("orderby", orderBy);

  return API.get(`/Time?${params.toString()}`);
};

export const getRecordedTimeForMatter = (
  matterId,
  status,
  FromDate,
  ToDate,
  page,
  limit,
  parameter,
) => {
  let url = `/Time/Matter/${matterId}?active=true&page=${page}&limit=${limit}`;
  if (status) {
    url += `&Billed=${status?.value}`;
  }
  if (FromDate) {
    url += `&FromDate=${FromDate}`;
  }
  if (ToDate) {
    url += `&ToDate=${ToDate}`;
  }
  if (parameter) {
    url += `&orderby=${parameter}`;
  }
  return API.get(url);
};

export const getClientsNameAndRef = () =>
  API.get(
    "Clients?active=true&orderby=clientRef&fields=clientid,clientRef,clientName",
  );

export const getActivityType = () =>
  API.get(
    "Clients?active=true&orderby=clientRef&fields=clientid,clientRef,clientName",
  );

export const addClient = (data) =>
  API.post(`/Clients`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const editClient = (id, data) =>
  API.patch(`/Clients/${id}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const getClientData = (id) => API.get(`/Clients/${id}`);

export const getUserClaims = () => {
  const { authServerUrl } = getAppConfig();
  return API.get(`${authServerUrl}/connect/userinfo`);
};

export const getWorkType = (id) => API.get(`/WorkTypes/${id}`);

export const getBillingTargets = (id) =>
  API.get(`/targets/${id}/Billing?Active=true`);

export const editBillingTargets = (id, data) =>
  API.put(`/targets/${id}/Billing`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const editAccessibleUsers = (id, data) =>
  API.put(`/Matters/${id}/UserAccess`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const editTimeTargets = (id, data) =>
  API.put(`/targets/${id}/Time`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const getTimeTargets = (id) => API.get(`/Targets/${id}/Time`);

export const getMattersRef = () => API.get(`/Matters?fields=matterid`);

export const getMatters = () => API.get(`/Matters/?orderby=matterRef`);

export const URL = `${baseURL}/Matters?`;

export const ClientURL = `${baseURL}/Clients?`;

export const getEmailDocumentBody = (id) => API.get(`/documents/${id}/email`);

export const getEmailFileBody = (id) => API.get(`/documents/file/${id}/email`);

export const getMattersdetails = (id) => API.get(`/Matters/${id}/basic`);

export const getMatterAllInfo = (id) => API.get(`/Matters/${id}`);

export const getMatterDocDuplicate = (matterId, activityId) =>
  API.get(`/MatterActivities/${matterId}/${activityId}/duplicate`);

export const copyMatterActivity = (matterId, activityId, targetMatterId) =>
  API.get(
    `/MatterActivities/${matterId}/${activityId}/Copy/${targetMatterId}`,
  );

export const getDocument = (id, specificVersion) => {
  if (specificVersion) {
    return API.get(`Documents/File/${id}`);
  } else {
    return API.get(`Documents/${id}`);
  }
};

export const getNewBlankDocument = ({ filename = "Document.docx", data }) =>
  API.post(
    `documents/File/${filename}?blankDocument=true`,
    JSON.stringify(data),
    { headers: { "Content-Type": "application/json" } },
  );

export const getDocumentEditor = (id, matterId) =>
  API.get(`documents/${id}/Edit/${matterId}`);

export const saveDocumentEditor = (id, matterId) =>
  API.post(`documents/${id}/Edit/${matterId}`);

export const getSumsubLevels = () => API.get(`/Sumsub/KycLevels`);

export const getSumsubSettings = () => API.get(`/Sumsub/Settings`);

export const saveSumsubSettings = (data) =>
  API.post(`/Sumsub/Settings`, JSON.stringify(data), {
    headers: { "Content-Type": "application/json" },
  });

export const postSumsubToken = (data) =>
  API.post(`sumsub/token`, JSON.stringify(data), {
    headers: { "Content-Type": "application/json" },
  });

export const cancelDocumentEditor = (id, matterId) =>
  API.delete(`documents/${id}/Edit/${matterId}`);

export const disconnectSumsub = () => API.delete(`/sumsub/token`);

export const createFileEntry = (file, data) =>
  API.post(`/Documents/File/${file} `, JSON.stringify(data), {
    headers: { "Content-Type": "application/json" },
  });

export const getDocIntelligenceData = (fileId) =>
  API.get(`/documents/File/${fileId}/Intelligence?analysisModel=iddocument`, {
    suppressErrorToast: true,
  });

export const uploadCompleted = (fileid) =>
  API.patch(`/Documents/File/${fileid}/uploaded`, {
    headers: { "Content-Type": "application/json" },
  });

export const getSingleContact = (contactId) =>
  API.get(`/Contacts/${contactId}`);

export const getSingleMatterActivity = (matterId, activityId) =>
  API.get(`/MatterActivities/${matterId}/${activityId}`);

export const getContactsInfo = (id) => API.get(`/Contacts/${id}`);

export const createNewContact = (data, type) =>
  API.post(`/Contacts`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const editContact = (id, data) =>
  API.patch(`/Contacts/${id}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const deleteContact = (id, forceDelete = false) =>
  API.delete(`/Contacts/${id}${forceDelete ? "?forceDelete=true" : ""}`);

export const updateMatterActivity = (matterId, id, data) =>
  API.patch(`/MatterActivities/${matterId}/${id}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const createTimeRecord = (data) =>
  API.post(`/Time`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const editTimeRecord = (data) =>
  API.patch(`/Time`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const getTimeRecord = (timeId) => API.get(`/Time/${timeId}`);

export const writeOffWIP = (matterId, data) =>
  API.post(`/Time/WriteOffWIP/${matterId}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const getMatterTimeRecords = (matterId) =>
  API.get(
    `/Time/Matter/${matterId}?active=true&billed=false&InBillRequest=false`,
  );

export const getMatterDefaults = (matterId) =>
  API.get(`/matters/${matterId}/defaults`);

export const getBillSettings = (matterId) =>
  API.get(`/Matters/${matterId}/BillSettings`);

export const updateBillSettings = (matterId, data) =>
  API.patch(`/Matters/${matterId}/BillSettings`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const postBill = (data) =>
  API.post(`/Bill`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const getActivePermissions = (id) =>
  API.get(`/Matters/${id}/UserAccess`);

export const getFileById = (fileID) =>
  API.get(`/Documents/File/${fileID}`, {
    headers: { "Content-Type": "application/json" },
  });

export const checkEmailAttached = (file) => {
  const formData = new FormData();
  formData.append("File", file, file.name);
  return API.post("/Documents/IsEmailAttached", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};



export const getDashboardMatterData = (
  teamId,
  feeEarnerRef,
  branchId,
  fromDate,
  toDate,
) => {
  let url = `/Dashboard/Matters?`;
  const parameters = constructApiQuery(
    branchId || null,
    teamId || null,
    feeEarnerRef || null,
  );

  if (fromDate) {
    url += `&FromDate=${fromDate}`;
  }
  if (toDate) {
    url += `&ToDate=${toDate}`;
  }

  if (Object.keys(parameters).length) {
    url += `&${Object.keys(parameters)[0]}=${Object.values(parameters)[0]}`;
  }
  return API.get(url);
};

export const getDashboardTimeTargetData = (
  teamId,
  feeEarnerRef,
  branchId,
  fromDate,
  toDate,
) => {
  let url = `/Dashboard/TimeTarget?`;
  const parameters = constructApiQuery(
    branchId || null,
    teamId || null,
    feeEarnerRef || null,
  );
  if (fromDate) {
    url += `&FromDate=${fromDate}`;
  }
  if (toDate) {
    url += `&ToDate=${toDate}`;
  }

  if (Object.keys(parameters).length) {
    url += `&${Object.keys(parameters)[0]}=${Object.values(parameters)[0]}`;
  }
  return API.get(url);
};

export const getClientsList = (page, limit, parameter, filterParameters) => {
  let url = `/clients?`;
  if (page) {
    url += `&page=${page}`;
  }
  if (limit) {
    url += `&limit=${limit}`;
  }
  if (parameter) {
    url += `&orderby=${parameter}`;
  }

  const parameters = constructApiQuery(
    filterParameters?.branch || null,
    filterParameters?.teamId || null,
    filterParameters?.feeEarnerRef || null,
  );

  if (Object.keys(parameters).length) {
    url += `&${Object.keys(parameters)[0]}=${Object.values(parameters)[0]}`;
  }
  if (filterParameters?.search) {
    url += `&search=${filterParameters?.search}`;
  }

  return API.get(url);
};


export const getMyMattersList = (page, limit, orderBy, filterParameters) => {
  let url = `/matters?`;
  if (page) {
    url += `&page=${page}`;
  }
  if (limit) {
    url += `&limit=${limit}`;
  }
  if (orderBy) {
    url += `&orderby=${orderBy}`;
  }
  if (filterParameters.appCode) {
    url += `&AppCode=${filterParameters.appCode}`;
  }
  if (filterParameters.feeEarnerRef) {
    url += `&FeeEarnerRef=${filterParameters.feeEarnerRef}`;
  }
  if (filterParameters.branch) {
    url += `&BranchId=${filterParameters.branch}`;
  }
  if (filterParameters.openFrom) {
    url += `&OpenStartDate=${filterParameters.openFrom}`;
  }
  if (filterParameters.openTo) {
    url += `&OpenEndDate=${filterParameters.openTo}`;
  }
  if (filterParameters.search) {
    url += `&search=${filterParameters.search}`;
  }
  return API.get(url);
};

export const createNewTeam = (data) =>
  API.post(`/Teams`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const editTeam = (data, id) =>
  API.patch(`/Teams/${id}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const getTeamsById = (id) => API.get(`/Teams/${id}/users`);

export const getTeams = () => API.get(`/Teams`);

export const addRemoveTeamMembers = (data, id) =>
  API.put(`/Teams/${id}/users`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const getNotificationProfiles = () => API.get(`/NotificationProfiles`);

export const getActiveNotificationProfiles = () =>
  API.get(`/NotificationProfiles?active=true`);

export const addNotificationProfile = (data) =>
  API.post(`/NotificationProfiles`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const updateNotificationProfile = (data, id) =>
  API.patch(`/NotificationProfiles/${id}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const getNotificationProfilesItems = () =>
  API.get(`/NotificationProfiles/Items`);

export const getSpecificNotificationProfile = (id) =>
  API.get(`/NotificationProfiles/${id}`);

export const updateSpecificNotificationProfile = (data, id) =>
  API.patch(`/NotificationProfiles/${id}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const getSecurityProfiles = () => API.get(`/Profiles`);

//Delete after using service
export const getActiveSecurityProfiles = () => API.get(`/Profiles?active=true`);

export const addSecurityProfile = (data) =>
  API.post(`/Profiles`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const updateSecurityProfile = (data, id) =>
  API.patch(`/Profiles/${id}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const getSecurityProfilesItems = () => API.get(`/Profiles/Items`);

export const getSpecificProfiles = (id) => API.get(`/Profiles/${id}`);

export const updateSpecificProfiles = (data, id) =>
  API.patch(`/Profiles/${id}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const vatReturnConnect = (data) =>
  API.post(`/VatReturn/HMRC/Connect`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const getVatReturnInfo = () => API.get(`/VatReturn/HMRC/AuthURL`);

export const checkVatReturnNo = (number) =>
  API.get(`/VatReturn/CheckVATNo/${number}`);

export const getVatObligations = () => API.get(`/vatreturn/obligations`);

export const getVatReturnHistory = () => API.get(`/VatReturn/VatHistory`);

export const getVatReturnData = (fromDate, toDate) => {
  const params = new URLSearchParams();
  if (fromDate) params.append("fromdate", fromDate);
  if (toDate) params.append("todate", toDate);
  return API.get(`/VatReturn?${params.toString()}`);
};

export const submitVatReturn = (data) =>
  API.post(`/VatReturn`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const getClioInfo = (redirectLocation) =>
  API.get(`/Clio/AuthURL?redirectURL=${redirectLocation}`);

export const disconnectClio = () =>
  API.post(`/clio/disconnect`, {
    headers: { "Content-Type": "application/json" },
  });

export const clioConnect = (data) =>
  API.post(`/Clio/Connect`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const clioSync = () =>
  API.post(`/Clio/SyncData`, {
    headers: { "Content-Type": "application/json" },
  });

export const hmrcSync = () =>
  API.post(`/VatReturn/HMRC/SyncObligations`, {
    headers: { "Content-Type": "application/json" },
  });

export const clioStatus = () => API.get(`/Clio/Status`);

export const getIntegrationDetails = () => API.get(`/integrations`);

export const getIntegrationDetailByType = (integrationType) => API.get(`/integrations/${integrationType}`);

export const getNotifications = () => API.get(`/Notifications`);

export const updateNotifications = (data, seen) =>
  API.put(`/Notifications/Seen`, JSON.stringify(data), {
    headers: { "Content-Type": "application/json" },
    ...(seen === false && { params: { seen: false } }),
  });

export const getClientRefExample = (
  clientName,
  lettersLength,
  numbersLength,
  nameType,
) => {
  const params = new URLSearchParams();
  params.append("clientname", clientName);

  if (lettersLength !== undefined) {
    params.append("lettersLength", lettersLength);
  }
  if (numbersLength !== undefined) {
    params.append("numbersLength", numbersLength);
  }
  if (nameType !== undefined) {
    params.append("nameType", nameType);
  }

  return API.get(`/Clients/NewClientRef?${params.toString()}`);
};

export const getMatterRefExample = (
  clientRef,
  selection,
  separator,
  numbersLength,
) => {
  if (
    selection === undefined &&
    numbersLength === undefined &&
    separator === undefined
  ) {
    return API.get(`/Matters/NewMatterRef?clientRef=${clientRef}`);
  }
  return API.get(
    `/Matters/NewMatterRef?clientRef=${clientRef}&selection=${selection}&separator=${separator}&numbersLength=${numbersLength}`,
  );
};

export const getCaseWorkFlows = (appCode) =>
  API.get(`/workflows/folders?appCode=${appCode}&active=true`);

export const addDocumentTemplate = (data) =>
  API.post(`Workflows/DocumentTemplate`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const editDocumentTemplate = (id, data) =>
  API.patch(`Workflows/DocumentTemplate/${id}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const addClientInterview = (data) =>
  API.post(`Workflows/ClientInterview`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const editClientInterview = (id, data) =>
  API.patch(`Workflows/ClientInterview/${id}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const getClientInterviews = () => API.get(`Workflows/ClientInterview`);

export const getCaseWorkFlowsItem = (appCode, parentId, searchValue) => {
  let url = `/workflows?appCode=${appCode}&ParentID=${parentId}&active=true&orderby=IsFolder desc, Order`;
  if (searchValue) url += `&Search=${encodeURIComponent(searchValue)}`;
  return API.get(url);
};

export const updateWorkFlow = (id, data) =>
  API.patch(`/Workflows/${id}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });
export const updateWorkflowOrder = (appCode, parentId, data) =>
  API.patch(
    `/Workflows/Order?appCode=${appCode}&ParentID=${parentId}&active=true&orderby=IsFolder desc, Order`,
    JSON.stringify({ data }),
    { headers: { "Content-Type": "application/json" } },
  );

export const getWorkFlowTemplates = () =>
  API.get(`/workflows/DocumentTemplate`);

export const getWorkFlowTemplatesById = (id) =>
  API.get(`/workflows/DocumentTemplate/${id}`);

export const getWorkFlowClientInterviews = () =>
  API.get(`/workflows/ClientInterview`);

export const getWorkFlowClientInterviewsById = (id) =>
  API.get(`/workflows/ClientInterview/${id}`);

export const getAllWorkFlowInterviews = () => API.get(`/UserScreens`);

export const addCaseWorkflowRecord = (data) =>
  API.post(`/Workflows`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const getWorkFlowInterviews = (userScreenId) =>
  API.get(`/UserScreens/${userScreenId}`);

export const getAllUserScreens = (screenType) =>
  API.get(`/UserScreens?Type=${screenType}`);

export const addUserScreen = (data) =>
  API.post(`/UserScreens`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const updateScreen = (data, userScreenId) =>
  API.patch(`/UserScreens/${userScreenId}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const getMatterVariables = (matterId, InterviewId) =>
  API.get(`/Matters/${matterId}/Variables?InterviewId=${InterviewId}`);

export const updateMatterVariables = (matterId, data) =>
  API.put(`/Matters/${matterId}/Variables`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const getContactsMatterData = (contactId) =>
  API.get(`/Contacts/${contactId}/Matters`);

export const createClientSetvicesTask = (matterId, data) =>
  API.post(`/ClientServices/${matterId}/Tasks`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const getContactDetails = (contactId) =>
  API.get(`/Contacts/${contactId}/People`);

export const attachMatterOnContact = (matterId, data) =>
  API.put(`/Matters/${matterId}/Contacts`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const getClientNotes = (clientId) =>
  API.get(`/Clients/${clientId}/Notes`);

export const getClientDocs = (clientId) =>
  API.get(`/Clients/${clientId}/DocumentRegisters`);

export const getClientDocumentsList = (clientId) =>
  API.get(`/Clients/${clientId}/Documents?active=true`);

export const getMatterNotes = (matterId) =>
  API.get(`/Matters/${matterId}/Notes`);

export const getMatterRiskAssessmentQuestions = (matterId) =>
  API.get(`/Matters/${matterId}/RiskAssessments`);

export const getClientRiskAssessmentQuestions = (clientId) =>
  API.get(`/Clients/${clientId}/RiskAssessments`);

export const saveMatterRiskAssessmentQuestions = (matterId, data) =>
  API.post(`/Matters/${matterId}/RiskAssessments`, JSON.stringify(data), {
    headers: { "Content-Type": "application/json" },
  });
export const saveClientRiskAssessmentQuestions = (clientId, data) =>
  API.post(`/Clients/${clientId}/RiskAssessments`, JSON.stringify(data), {
    headers: { "Content-Type": "application/json" },
  });

export const addMatterNotes = (data, matterId) =>
  API.post(`/Matters/${matterId}/Notes`, JSON.stringify(data), {
    headers: { "Content-Type": "application/json" },
  });

export const updateMatterNotes = (data, noteId) =>
  API.patch(`/Matters/Notes/${noteId}`, JSON.stringify(data), {
    headers: { "Content-Type": "application/json" },
  });

export const addClientNotes = (data, clientId) =>
  API.post(`/Clients/${clientId}/Notes`, JSON.stringify(data), {
    headers: { "Content-Type": "application/json" },
  });

export const updateClientNotes = (data, noteId) =>
  API.patch(`/Clients/Notes/${noteId}`, JSON.stringify(data), {
    headers: { "Content-Type": "application/json" },
  });

export const getDocumentRegisters = (docId) =>
  API.get(`/DocumentRegister/${docId}`);

export const addMatterDocumentResgisters = (data, matterId) =>
  API.post(`/DocumentRegister/Matter/${matterId}`, JSON.stringify(data), {
    headers: { "Content-Type": "application/json" },
  });

export const updateDocumentResgister = (data, docId) =>
  API.patch(`/DocumentRegister/${docId}`, JSON.stringify(data), {
    headers: { "Content-Type": "application/json" },
  });

export const addClientDocumentResgisters = (data, clientId) =>
  API.post(`/DocumentRegister/Client/${clientId}`, JSON.stringify(data), {
    headers: { "Content-Type": "application/json" },
  });

export const addClientDocumentItem = (data, clientId) =>
  API.post(`/Clients/${clientId}/Documents`, JSON.stringify(data), {
    headers: { "Content-Type": "application/json" },
  });

export const updateClientDocumentItem = (data, clientId, documentId) =>
  API.patch(
    `/Clients/${clientId}/Documents/${documentId}`,
    JSON.stringify(data),
    { headers: { "Content-Type": "application/json" } },
  );

export const getSupplierDocumentsList = (supplierId) =>
  API.get(`/Suppliers/${supplierId}/Documents?active=true`);

export const addSupplierDocumentItem = (data, supplierId) =>
  API.post(`/Suppliers/${supplierId}/Documents`, JSON.stringify(data), {
    headers: { "Content-Type": "application/json" },
  });

export const updateSupplierDocumentItem = (data, supplierId, documentId) =>
  API.patch(
    `/Suppliers/${supplierId}/Documents/${documentId}`,
    JSON.stringify(data),
    { headers: { "Content-Type": "application/json" } },
  );

export const getContactDocumentsList = (contactId, search) =>
  API.get(
    `/Contacts/${contactId}/Documents?active=true${
      search ? `&search=${encodeURIComponent(search)}` : ""
    }`,
  );

export const getContactDocumentDetail = (contactId, contactDocumentId) =>
  API.get(`/Contacts/${contactId}/Documents/${contactDocumentId}`);

export const addContactDocumentItem = (data, contactId) =>
  API.post(`/Contacts/${contactId}/Documents`, JSON.stringify(data), {
    headers: { "Content-Type": "application/json" },
  });

export const updateContactDocumentItem = (data, contactId, contactDocumentId) =>
  API.patch(
    `/Contacts/${contactId}/Documents/${contactDocumentId}`,
    JSON.stringify(data),
    { headers: { "Content-Type": "application/json" } },
  );

export const getMatterDocs = (matterId) =>
  API.get(`/Matters/${matterId}/DocumentRegisters`);

export const getEstimates = (matterId) =>
  API.get(`/Matters/${matterId}/Estimates`);

export const updateEstimate = (data, matterId, estimateId) =>
  API.patch(
    `/Matters/${matterId}/Estimates/${estimateId}`,
    JSON.stringify(data),
    { headers: { "Content-Type": "application/json" } },
  );

export const addEstimate = (data, matterId) =>
  API.post(`/Matters/${matterId}/Estimates`, JSON.stringify(data), {
    headers: { "Content-Type": "application/json" },
  });

export const getClientVerifications = (clientId) =>
  API.get(`/Verifications/${clientId}`);

export const getClientRiskAssessmentSettings = (clientId) =>
  API.get(`RiskAssessments/ClientType/${clientId}`);
export const getMatterRiskAssessmentSettings = (workTypeId) =>
  API.get(`RiskAssessments/WorkType/${workTypeId}`);

export const editClientRiskAssessmentSettings = (clientId, data) =>
  API.post(`RiskAssessments/ClientType/${clientId}`, JSON.stringify(data), {
    headers: { "Content-Type": "application/json" },
  });

export const editMatterRiskAssessmentSettings = (workTypeId, data) =>
  API.post(`RiskAssessments/WorkType/${workTypeId}`, JSON.stringify(data), {
    headers: { "Content-Type": "application/json" },
  });
export const updateProof = (data, clientId, proofId) =>
  API.patch(
    `/Verifications/${clientId}/Proof/${proofId}`,
    JSON.stringify(data),
    { headers: { "Content-Type": "application/json" } },
  );

export const addProof = (data, clientId) =>
  API.post(`/Verifications/${clientId}/Proof`, JSON.stringify(data), {
    headers: { "Content-Type": "application/json" },
  });

export const addDirector = (data, clientId) =>
  API.post(`/Verifications/${clientId}/Person`, JSON.stringify(data), {
    headers: { "Content-Type": "application/json" },
  });

export const updateDirector = (data, clientId, companyPersonId) =>
  API.patch(
    `/Verifications/${clientId}/Person/${companyPersonId}`,
    JSON.stringify(data),
    { headers: { "Content-Type": "application/json" } },
  );

export const addOwners = (data, clientId) =>
  API.put(`/Verifications/${clientId}/Owners`, JSON.stringify(data), {
    headers: { "Content-Type": "application/json" },
  });

export const addRiskAssessmentQuestion = (data) =>
  API.post(`/RiskAssessments/Questions`, JSON.stringify(data), {
    headers: { "Content-Type": "application/json" },
  });

export const editRiskAssessmentQuestion = (data, id) =>
  API.patch(`/RiskAssessments/Questions/${id}`, JSON.stringify(data), {
    headers: { "Content-Type": "application/json" },
  });
export const getRiskAssessmentQuestions = (workTypeId) =>
  API.get(`/RiskAssessments/Questions`);

export const updateRiskAssessmentDefault = (data) =>
  API.post(`/RiskAssessments/Default`, JSON.stringify(data), {
    headers: { "Content-Type": "application/json" },
  });

export const getRiskAssessmentDefault = () =>
  API.get(`/RiskAssessments/Default`);

export const getMatterRates = (matterId, userRef) =>
  API.get(`/Matters/${matterId}/Rates/${userRef}`);

export const getRateCategories = () =>
  API.get(`/rates/RateCategories?active=true`);

export const getRateCategoriesbyAppCode = (appCode) =>
  API.get(
    `/rates/RateCategories?active=true&appCode=${appCode}&orderby=rateCategoryName`,
  );

export const getUserRatebyCategory = (categoryId) =>
  API.get(`/rates/${categoryId}`);

export const updateUserRates = (categoryId, data) =>
  API.put(`/rates/${categoryId}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const createRateCategory = (data) =>
  API.post(`/rates/RateCategories`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const updateRateCategory = (categoryId, data) =>
  API.patch(`/rates/RateCategories/${categoryId}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const searchCompanies = (term) =>
  API.get(`/utilities/companieshouse/SearchCompanies?term=${term}`);

export const searchConflictCheck = (data) =>
  API.post(`/ConflictCheck/Search`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const saveConflictCheckResults = (matterId, data) =>
  API.post(
    `/CaseFile/${matterId}/conflictCheck/save`,
    JSON.stringify({ data }),
    { headers: { "Content-Type": "application/json" } },
  );

export const saveClientConflictCheckToClient = (clientId, data) =>
  API.post(
    `/clients/${clientId}/ConflictCheck/Save`,
    JSON.stringify({ data }),
    { headers: { "Content-Type": "application/json" } },
  );

export const getCompanyProfile = (companyNumber) =>
  API.get(`/utilities/companieshouse/CompanyProfile/${companyNumber}`);

export const getDocumentVerions = (documentId) =>
  API.get(`/documents/${documentId}/versions`);

export const getDocumentSummary = (documentId, params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  const url = queryString
    ? `/documents/${documentId}/summary?${queryString}`
    : `/documents/${documentId}/summary`;
  return API.get(url);
};

export const downloadDocument = (documentId) =>
  API.get(`/documents/${documentId}/download`, {
    responseType: "blob", // Important for correct file download
  });

export const downloadDocumentAsPDF = (documentId) =>
  API.get(`/documents/${documentId}/download/pdf`, { responseType: "blob" });

export const downloadDocumentsAsZip = (zipFileName, documentIds) =>
  API.post(
    `/documents/download/zip/${zipFileName}`,
    JSON.stringify(documentIds),
    { responseType: "blob", headers: { "Content-Type": "application/json" } },
  );

export const shareDocument = (matterId, data) =>
  API.post(`/casefile/${matterId}/sharedocument`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const shareDocumentOutlookWebURL = (matterId, data) =>
  API.post(
    `/CaseFile/${matterId}/ShareDocument/OutlookWebURL`,
    JSON.stringify({ data }),
    { headers: { "Content-Type": "application/json" } },
  );

export const runDocumentTemplate = (matterId, documentId) =>
  API.get(`/DocumentTemplates/RunTemplate/${matterId}/${documentId}`);

export const runClientInterview = (matterId, workflowItemId) =>
  API.get(`/ClientInterviews/${matterId}/${workflowItemId}`);

export const sendInterviewtoClient = (matterId, workflowItemId, data) =>
  API.post(
    `/ClientInterviews/${matterId}/${workflowItemId}`,
    JSON.stringify(data),
    { headers: { "Content-Type": "application/json" } },
  );
export function constructApiQuery(branch, team, feeEarner) {
  let query = {};
  if (feeEarner && feeEarner !== "ALL") {
    query.FeeEarnerRef = feeEarner;
  } else if (team && team > 0) {
    query.TeamID = team;
  } else if (branch && branch > 0) {
    query.BranchId = branch;
  }

  return query;
}

export const getMatterTasks = (
  matterId,
  completed,
  FromDate,
  ToDate,
  page,
  limit,
  parameter,
) => {
  let url = `/Tasks/matter/${matterId}?active=true&page=${page}&limit=${limit}&completed=false`;
  if (FromDate) {
    url += `&FromDate=${FromDate}`;
  }
  if (ToDate) {
    url += `&ToDate=${ToDate}`;
  }
  if (parameter) {
    url += `&orderby=${parameter}`;
  }
  if (completed) {
    url = url.replace("&completed=false", "");
  }

  return API.get(url);
};

export const addMatterTask = (matterId, data) =>
  API.post(`/Tasks/matter/${matterId}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const updateMatterTask = (taskId, data) =>
  API.patch(`/Tasks/${taskId}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const getClientMessages = (matterId) =>
  API.get(`/ClientServices/${matterId}/Messages`);
export const sendClientMessage = (matterId, data) =>
  API.post(`/ClientServices/${matterId}/Messages`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const getSuggestedEmails = (matterId) =>
  API.get(`/Matters/${matterId}/Contacts/email`);

export const getNewEmail = (matterId, units) =>
  API.get(`/Matters/${matterId}/newemail?units=${units}`);

export const postESigning = (matterId, activityId, data) =>
  API.post(
    `/MatterActivities/${matterId}/${activityId}/ESign`,
    JSON.stringify({ data }),
    { headers: { "Content-Type": "application/json" } },
  );

export const getClientServicesTasks = (matterId) =>
  API.get(`/ClientServices/${matterId}/Tasks`);

export const getClientLoginAccess = (clientId, matterId) =>
  API.get(`/ClientServices/Portal/${clientId}/loginlink?matterid=${matterId}`);

export const getWorkTypeEngagementLetters = (workTypeId) =>
  API.get(`/WorkTypes/${workTypeId}/letters?active=true`);

export const updateWorkTypeEngagementLetters = (workTypeId, data) =>
  API.patch(`/WorkTypes/${workTypeId}/letters`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const runTemplateForEngagementLetter = (templateId, matterId) =>
  API.get(`/Workflows/DocumentTemplate/${templateId}/RunTemplate/${matterId}`);

export const getClientTasksTemplate = (workTypeId) =>
  API.get(`/WorkTypes/${workTypeId}/ClientTasks`);

export const startOnboarding = (data) =>
  API.post(`/Onboarding`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const updateOnboarding = (data, onboardingId) =>
  API.patch(`/Onboarding/${onboardingId}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const getOnboarding = (onboardingId) =>
  API.get(`/Onboarding/${onboardingId}`);

export const getYearEnd = (data) =>
  API.post(`/FinancialProcessing/YearEnd`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const rebuildRetainedProfit = (data) =>
  API.post(`/FinancialProcessing/RetainedProfit`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const getUnpaidDisbursements = (params) => {
  const queryParams = new URLSearchParams();

  if (params.MatterId) queryParams.append("MatterId", params.MatterId);
  if (params.SupplierRef) queryParams.append("SupplierRef", params.SupplierRef);
  if (params.FromDate) queryParams.append("FromDate", params.FromDate);
  if (params.ToDate) queryParams.append("ToDate", params.ToDate);
  if (params.PayWhenPaid !== undefined)
    queryParams.append("PayWhenPaid", params.PayWhenPaid);
  if (params.TransactionType !== undefined && params.TransactionType !== null) {
    queryParams.append("TransactionType", params.TransactionType);
  }
  if (params.Page) queryParams.append("Page", params.Page);
  if (params.Limit) queryParams.append("Limit", params.Limit);
  if (params.OrderBy) queryParams.append("OrderBy", params.OrderBy);

  return API.get(`/Postings/Supplier/UnpaidDisb?${queryParams.toString()}`);
};

export const getUndertaking = (undertakingId) =>
  API.get(`/Undertaking/${undertakingId}`);

export const addUndertaking = (data) =>
  API.post(`/Undertaking`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const updateUndertaking = (undertakingId, data) =>
  API.patch(`/Undertaking/${undertakingId}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const getClientUndertakings = (clientId) =>
  API.get(`/Undertaking/client/${clientId}`);

export const getMatterUndertakings = (matterId) =>
  API.get(`/Undertaking/Matter/${matterId}`);

export const getOutlookWebURLViewEmail = (docId) =>
  API.get(`/Documents/${docId}/OutlookWebURL`);

export const getMyTasks = (date) =>
  API.get(
    `/Tasks/me?active=true&completed=false${date ? `&toduedate=${date}` : ""}`,
  );
